// extracted by mini-css-extract-plugin
export default {"background":"ahoH2","language-de":"G_upM","language-en":"oz3Ka","language-es":"dPPCr","language-fr":"BYSAe","language-it":"cUVRD","language-nl":"ZzqQT"};